import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ACTIONS } from '../../constants';
import { getLast } from '../../util/guards';
import { TItem } from '../reducers/types';
import { selectItems, selectUnreadCount } from '../selectors/chat';
import { needMarkMessageAsUnread } from '../utils';
import { usePrevious } from './usePrevious';

export const useUnreadMessageCounter = (isChatbotOpen: boolean) => {
  const dispatch = useDispatch();
  const items = useSelector(selectItems);
  const previousItems = usePrevious(items);
  const lastMessage = getLast(items);
  const unreadCount = useSelector(selectUnreadCount);

  const onMessagesChange = useCallback(
    (messages: TItem[]) => {
      if (isChatbotOpen) {
        return;
      }

      const lastChangedMessage = getLast(messages);
      const isInitialMessages = previousItems === undefined;

      if (!isInitialMessages && needMarkMessageAsUnread(lastChangedMessage)) {
        dispatch({ type: ACTIONS.INCREASE_UNREAD_COUNT });
      }
    },
    [isChatbotOpen, previousItems, dispatch],
  );

  useEffect(() => {
    onMessagesChange(items);
  }, [items, lastMessage]);

  useEffect(() => {
    if (isChatbotOpen) {
      unreadCount && dispatch({ type: ACTIONS.RESET_UNREAD_COUNT });
    }
  }, [isChatbotOpen]);
};
